import { useCallback, useRef, useState } from 'react';
import type { Swiper as SwiperType } from 'swiper';

export const useWhatsNewModalSwiper = (slideCount: number) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const swiperRef = useRef<SwiperType | null>(null);

  const handleSlideChange = useCallback((index: number) => {
    setActiveIndex(index);
  }, []);

  const handleSwiper = useCallback((swiper: SwiperType) => {
    swiperRef.current = swiper;
  }, []);

  const handleBulletClick = useCallback((index: number) => {
    swiperRef.current?.slideTo(index);
  }, []);

  return {
    activeIndex,
    slideCount,
    handleSlideChange,
    handleSwiper,
    handleBulletClick,
  };
};
